var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"prop":"orderNumber","label":"订单编号"}}),_c('el-table-column',{attrs:{"prop":"courseTitle","label":"名称"}}),_c('el-table-column',{attrs:{"prop":"coursePrice","label":"价格","width":"180"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }